const appConfig = {
  name: process.env.REACT_APP_ORGANIZATION_NAME,
  shortName: process.env.REACT_APP_ORGANIZATION_SHORT_NAME,
  icon: process.env.REACT_APP_ORGANIZATION_MINI_LOGO,
  headericon: process.env.REACT_APP_ORGANIZATION_LOGO,
  setuserpageicon: process.env.REACT_APP_ORGANIZATION_INVERTED_LOGO,
};

export default appConfig;
